import { queryOptions, type QueryClient } from '@tanstack/react-query';

import { PracticeApi } from '@api/PracticeApi';

export const userPracticeAssistantKeys = {
    all: ['userPracticeAssistants'] as const,
    lists: () => [...userPracticeAssistantKeys.all, 'list'] as const,
    byUserId: (userId: string) => [...userPracticeAssistantKeys.lists(), { userId }] as const,
};

export const userPracticeAssistantQueryOptions = {
    byUserId: (userId: string) =>
        queryOptions({
            queryKey: userPracticeAssistantKeys.byUserId(userId),
            queryFn: () => PracticeApi.getUserAssistantsList(userId),
        }),
};

export function invalidateUserPracticeAssistants(queryClient: QueryClient, userId: string): Promise<void> {
    return queryClient.invalidateQueries({ queryKey: userPracticeAssistantKeys.byUserId(userId) });
}
